import { pgTable, text, timestamp, uuid, index } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const dsarRequests = pgTable(
  "dsar_requests",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    personId: uuid("person_id").notNull(),
    requestType: text("request_type").notNull(),
    status: text("status").notNull().default("pending"),
    requestedAt: timestamp("requested_at", tz).notNull().defaultNow(),
    deadlineAt: timestamp("deadline_at", tz).notNull(),
    completedAt: timestamp("completed_at", tz),
    requestedBy: text("requested_by").notNull(),
    resultPath: text("result_path"),
    rejectionReason: text("rejection_reason"),
    notes: text("notes"),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_dsar_requests_tenant").on(table.tenantId),
    index("idx_dsar_requests_status").on(table.status),
    index("idx_dsar_requests_person").on(table.tenantId, table.personId),
  ],
);
